export function extractDomain(websiteUrl: string): string {
  try {
    let url = websiteUrl.trim();
    if (!url) return '';
    if (!/^https?:\/\//i.test(url)) url = 'https://' + url;
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
}

export function getLogoUrl(websiteUrl: string): string {
  const domain = extractDomain(websiteUrl);
  if (!domain) return '';
  return `https://logos.hunter.io/${domain}`;
}

export function resolveLogoUrl(storedUrl: string, websiteUrl: string): string {
  if (storedUrl && !storedUrl.includes('logo.clearbit.com') && !storedUrl.includes('google.com/s2/favicons')) {
    return storedUrl;
  }
  return getLogoUrl(websiteUrl);
}
